import { Box, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";

import {
  flexAlignEnd,
  flexAllCentre,
  flexAllStart,
} from "../../styles/mui/styles/display";
import {
  acceptStyle,
  dragAndDropStyle,
  FaDownloadIcon,
  FileText,
  ReferralDocMain,
  rejectStyle,
} from "../styles/styles";
import { useMemo } from "react";
import colors from "../../styles/colors/colors";
import fontWeight from "../../styles/mui/fontWeight";
import { ButtonMinWidth } from "../../routes/PriorAuthWorkFlow/styles/style";
import { documentMaxFileSize } from "../../constants/Config";
import { italicFont } from "../../styles/mui/styles/font";
import { DropzoneInputProps, DropzoneRootProps } from "react-dropzone";

interface ReferralDocumentProps {
  isDragAccept: boolean;
  isDragReject: boolean;
  disabled?: boolean;
  isVisible: boolean;
  getRootReferralFileProps: <T extends DropzoneRootProps>(props?: T) => T;
  getReferralFileProps: <T extends DropzoneInputProps>(props?: T) => T;
  open: () => void;
  fileRejectionItems: JSX.Element[];
}

const ReferralDocument = ({
  isDragAccept,
  isDragReject,
  disabled,
  isVisible,
  getRootReferralFileProps,
  getReferralFileProps,
  open,
  fileRejectionItems,
}: ReferralDocumentProps) => {
  const style = useMemo(
    () => ({
      ...dragAndDropStyle,
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragAccept, isDragReject]
  );
  return (
    <Box>
      <Grid container sx={[flexAllCentre, ReferralDocMain]}>
        <Grid
          size={{ xs: 2 }}
          {...getRootReferralFileProps({
            style,
          })}
        >
          <Grid container>
            <Grid sx={flexAlignEnd}>
              <input
                className="input-zone"
                {...getReferralFileProps()}
                disabled={disabled}
              />
              <Box
                sx={flexAlignEnd}
                style={disabled ? { opacity: 0.5, pointerEvents: "none" } : {}}
              >
                <FaDownloadIcon />
                <Typography
                  variant="body1"
                  color={colors.fonts[4]}
                  fontWeight={fontWeight[5]}
                  pl={"1rem"}
                >
                  Drop file here
                </Typography>
              </Box>
              <Box sx={FileText}></Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid size={{ xs: 2 }} sx={flexAllCentre}>
          <Typography
            variant="body1"
            color={colors.fonts[4]}
            fontWeight={fontWeight[4]}
            style={disabled ? { opacity: 0.5 } : {}}
          >
            OR
          </Typography>
        </Grid>
        <Grid size={{ xs: 5 }}>
          <Grid container sx={flexAllStart}>
            <Grid p="1rem" size={{ xs: 12 }} sx={flexAllStart}>
              <Button
                onClick={open}
                variant="contained"
                sx={ButtonMinWidth}
                disabled={disabled}
              >
                Browse
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid size={{ xs: 12 }} sx={flexAllCentre}>
          <Typography
            variant="subtitle2"
            color={colors.red[100]}
            fontWeight={fontWeight[4]}
          >
            *Maximum Upload File Size: {documentMaxFileSize}.
          </Typography>
        </Grid>

        <Grid size={{ xs: 12 }} pt={1} sx={[flexAllCentre, italicFont]}>
          {isVisible && (
            <Typography
              variant="subtitle2"
              color={colors.fonts[4]}
              fontWeight={fontWeight[4]}
            >
              To select multiple files: hold the CTRL key and select each file
              for uploading.
            </Typography>
          )}
        </Grid>
      </Grid>
      {fileRejectionItems}
    </Box>
  );
};

export default ReferralDocument;
